<template>
  <div>
    <!-- 主要内容 begin -->
    <div id="content-main">
      <!-- 操作栏 -->
      <div class="flex-between">
        <div class="flex-start">
          <div class="search-item">
            <a-select
              v-model="category_id"
              placeholder="请选择"
              :options="categoryOptions"
              :allowClear="true"
              style="width: 200px"
            ></a-select>
            <a-input
              v-model="keyword"
              placeholder="请输入分类名称"
              :allowClear="true"
              style="width: 200px; margin:0 10px"
            />
            <a-button type="primary" icon="search" @click="search">搜索</a-button>
            <a-button type="primary" @click="refresh" style="margin-left:10px">重置</a-button>
          </div>
        </div>
        <a-button type="primary" icon="plus" @click="add">新建</a-button>
      </div>
      <!-- 分割线 -->
      <a-divider />
      <!-- 列表 -->
      <a-table :columns="columns" :data-source="list">
        <template slot="cover" slot-scope="text">
          <a-avatar :src="text.url" />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="edit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定删除?"
            @confirm="() => deleteItem(record.id)"
          >
            <a style="color:red">删除</a>
          </a-popconfirm>
        </template>
      </a-table>

      <!-- 分页 -->
      <Pagination :current="current" :pageSize="pageSize" :total="total" />
    </div>
    <!-- 主要内容 end -->

    <!-- 弹出： 新增编辑 -->
    <a-modal
      v-if="visible"
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submit"
      @cancel="cancel"
      :width="750"
    >
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        v-bind="layout"
      >
        <a-form-model-item has-feedback label="上级" prop="category">
          <a-select
            v-model="ruleForm.category"
            show-search
            placeholder="请选择"
            :options="categoryOptions"
          ></a-select>
        </a-form-model-item>
        <a-form-model-item has-feedback label="分类名称" prop="name">
          <a-input v-model="ruleForm.name" />
        </a-form-model-item>
        <a-form-model-item has-feedback label="排序" prop="sort">
          <a-input-number v-model="ruleForm.sort" />
          *越大越靠前
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import Pagination from "../components/Pagination.vue";

let ruleFormInit = {
  category: "",
  name: "",
  sort: 0
}

export default {
  components: {
    Pagination
  },
  data() {
    return {
      category_id: undefined,
      detail: null,
      title: "",
      visible: false,
      confirmLoading: false,
      list: [],
      total: 0,
      // 查询参数
      pageSize: 10,
      current: 1,
      keyword: "",
      columns: [
        {
          title: "上级",
          dataIndex: "category.name",
          width: 200
        },
        {
          title: "分类名称",
          dataIndex: "name",
        },
        {
          title: "排序",
          dataIndex: "sort",
          width: 200
        },
        {
          title: "创建时间",
          dataIndex: "createdTime",
          width: 200
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          width: 200
        },
        {
          title: "操作",
          key: "operation",
          width: 240,
          scopedSlots: {
            customRender: "operation"
          }
        }
      ],
      ruleForm: ruleFormInit,
      rules: {
        category: [{ required: true, trigger: "change", message: "必选" }],
        name: [{ required: true, trigger: "blur", message: "必填" }],
        sort: [{ required: true, trigger: "blur", message: "必填" }],
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 }
      },
      categoryOptions: []
    };
  },
  created() {
    this.getList();
    this.api.getCategoryList({}, res => {
      this.categoryOptions = [];
      res.data &&
        res.data.list.forEach(item => {
          this.categoryOptions.push({
            value: item.id,
            label: item.name
          });
        });
    });
  },
  methods: {
    async add() {
      this.title = "新建";
      this.visible = true;
    },
    async edit(item) {
      this.detail = {
        id: item.id,
        category: item.category.id,
        name: item.name,
        sort: item.sort
      };
      this.ruleForm = this.detail;
      this.title = "编辑";
      this.visible = true;
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            ...this.ruleForm
          };
          if (this.detail) {
            this.api.updateSubCategory(
              { id: this.detail.id, ...params },
              res => {
                if (res.success) {
                  this.$notification.success({
                    message: "提交成功",
                    description: res.message
                  });
                  this.cancel();
                  this.getList();
                } else {
                  this.$notification.error({
                    message: "错误警告！",
                    description: res.message
                  });
                }
              }
            );
          } else {
            this.api.createSubCategory(params, res => {
              if (res.success) {
                this.$notification.success({
                  message: "提交成功",
                  description: res.message
                });
                this.cancel();
                this.refresh();
              } else {
                this.$notification.error({
                  message: "错误警告！",
                  description: res.message
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancel() {
      this.detail = null;
      this.ruleForm = ruleFormInit;
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
    uploadChange(info) {
      console.log(info);
      let fileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-1);

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });

      this.ruleForm.cover = fileList;
    },
    // 重置刷新
    refresh() {
      this.pageSize = 10
      this.current = 1
      this.keyword = ""
      this.category_id = undefined
      this.getList();
    },
    // 查询
    search() {
      this.current = 1;
      this.getList();
    },
    // 列表方法
    getList() {
      this.loading = true;
      let params = {
        limit: this.pageSize,
        current: this.current,
        keyword: this.keyword,
        category_id: this.category_id || null
      };
      this.api.getSubCategoryList(params, res => {
        this.loading = false;
        if (res.success) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    },
    // 分页方法
    handleTableChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },
    deleteItem(id) {
      console.log("delete", id);
      this.api.deleteSubCategory({ id: id }, res => {
        if (res.success) {
          this.$notification.success({
            message: "删除成功",
            description: res.message
          });
          this.refresh();
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    }
  }
};
</script>
